import React from 'react';
import { Form } from 'fw/forms';
import { Col, Row, Modal, Label } from 'react-bootstrap';
import { ContentBody, VeteranAppIdHeader } from 'areas/shared/components';
import VeteranOwnerList from './VeteranOwnerList';
import PointOfContactList from './PointOfContactList';
import * as FormManager from 'fw/forms/form/FormManager';

class VeteranOwnerInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return { form: this.props.stepData, showOwnershipChangeModal: false };
    }

    componentDidMount() {
        if (this.state.form.veteranOwnerList.length === 0) {
            this.addVeteranOwner(0);
        }
    }

    updatePostData = (form, dirty) => {
        this.setState({ form });
        this.props.onStepChange(form);

        if (dirty === true && this._form !== null)
            FormManager.dirt(this._form);
    }

    addVeteranOwner = (order) => {
        let item = {
            veteranOwnerId: -Math.abs(Date.now() | 0),
            isOwnerVeteran: (order === 0) ? true : false,
            fromRenewal: this.props.stepInfo.isRenewal,
            order: order,
            phones: [{
                phoneTypeCode: "MOBILE",
                number: "",
                extension: "",
				countryCode: "+1",
                phoneId: -Math.abs(Date.now() | 0)
            }]
        }

        let form = this.state.form;
        form.newOwnerFromRenewal = this.props.stepInfo.isRenewal;
        form.veteranOwnerList = form.veteranOwnerList.concat(item)

        this.updatePostData(form);

        if (!this.state.form.ownersUpdatedFlagged && this.props.stepInfo.isRenewal)
            this.showOwnerUpdatedPopup();
    }

    renderOwnershipChangeModal = () => {
        return (
            <Modal
                size="sm"
                show={this.state.showOwnershipChangeModal}
            >
                <Modal.Body style={{ backgroundColor: "#99ccff", textAlign: "center" }}>
                    <button 
                        type="button"
                        class="close pull-right"
                        onClick={this.closeOwnershipChangeModal}
                    >
                        <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                    </button>
                    <br />
                    <h3> Chage in Ownership requires you to contact NVBDC Administration at</h3>
                    <h2> <strong>(586) 983-9955</strong></h2>
                    <br />
                    <br />
                </Modal.Body>
            </Modal>
        );
    }

    showOwnerUpdatedPopup = () => {
        let form = this.state.form;
        form.ownersUpdatedFlagged = true;

        this.setState((prevState) => { 
            return { 
                showOwnershipChangeModal: true,
                form: form
            };
        });
        setInterval(() => this.closeOwnershipChangeModal(), 10000);
    }

    closeOwnershipChangeModal = () => {
        this.setState((prevState) => { 
            return { 
                showOwnershipChangeModal: false
            }; 
        });
    }

    onDeleteVeteranOwner = (index) => {
        let form = this.state.form;
        let item = form.veteranOwnerList[index];

        if (this.props.stepInfo.isRenewal && !this.state.form.ownersUpdatedFlagged && !item.fromRenewal)
            this.showOwnerUpdatedPopup();

        form.veteranOwnerList.splice(index, 1);
        form.newOwnerFromRenewal = this.props.stepInfo.isRenewal && form.veteranOwnerList.some(x => x.fromRenewal);

        this.updatePostData(form, true);
    }

    onUpdateVeteranOwnerList = (index, item) => {
        let form = this.state.form;

        form.veteranOwnerList[index] = item;
        this.updatePostData(form, true);
    }

    addPointOfContact = (order) => {
        let item = {
            pointOfContactId: -Math.abs(Date.now() | 0),
            order: order
        }

        let form = this.state.form
        form.pointOfContactList = form.pointOfContactList.concat(item)

        this.updatePostData(form)
    }

    onDeletePointOfContact = (index) => {
        let form = this.state.form

        form.pointOfContactList.splice(index, 1)

        this.updatePostData(form, true)
    }
    
    onUpdatePointOfContactList = (index, item) => {
        let form = this.state.form

        form.pointOfContactList[index] = item
        this.updatePostData(form, true)
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    renderOwnersUpdatedFlagged = () => {
        if (this.props.stepInfo.ownersUpdatedFlagged !== true)
            return null;

        return (
            <React.Fragment>
                &nbsp;&nbsp;
                <Label style={{ color: "#FFFFFF", backgroundColor: "#ba1111" }}>
                    <span>Owners Updated</span>
                </Label>
            </React.Fragment>
        );
    }

    render() {
        return (
            <Form
                onChange={this.updatePostData}
                values={this.state.form}
                unsavedChangesWarning={true}
                disabled={this.props.stepInfo.readonly}
                ref={(form) => { this._form = form }}>
                <div>
                    <ContentBody>
                        {this.renderOwnershipChangeModal()}
                        <Row>
                            <Col md={12}>
                                <Row>
                                    <Col md={12}>
                                        <h3 style={{ position: 'relative' }}>
                                            Veteran Owner Information&nbsp;–&nbsp; 
                                            <small>
                                                Please submit all required Veteran Owner Information
                                                {this.renderOwnersUpdatedFlagged()}
                                            </small>
                                            <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} />
                                        </h3>
                                        <hr />
                                    </Col>
                                </Row>
                                <VeteranOwnerList 
                                    isRenewal={this.props.stepInfo.isRenewal}
                                    newOwnerFromRenewal={this.state.form.newOwnerFromRenewal}
                                    veteranOwnerList={this.state.form.veteranOwnerList}
                                    ownersUpdatedFlagged={this.state.form.ownersUpdatedFlagged}
                                    showOwnerUpdatedPopup={this.showOwnerUpdatedPopup}
                                    addVeteranOwner={this.addVeteranOwner}
                                    onDeleteVeteranOwner={this.onDeleteVeteranOwner}
                                    onUpdateVeteranOwnerList={this.onUpdateVeteranOwnerList}
                                    formSF180StorageToken={this.state.form.formSF180StorageToken}
                                    formSF180fileName={this.state.form.formSF180fileName}
                                    tooltips={this.props.stepInfo.tooltips}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <h3>Points of Contact</h3>
                                <hr />
                                <PointOfContactList 
                                    pointOfContactList={this.state.form.pointOfContactList}
                                    addPointOfContact={this.addPointOfContact}
                                    onDeletePointOfContact={this.onDeletePointOfContact}
                                    onUpdatePointOfContactList={this.onUpdatePointOfContactList}
                                    tooltips={this.props.stepInfo.tooltips}
                                />
                            </Col>
                        </Row>
                    </ContentBody>
                </div>
            </Form>)
    }
}

export default VeteranOwnerInfo;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/veteranOwnerInfo/VeteranOwnerInfo.js